module.exports = __webpack_public_path__ + "static/media/icon-person-outline.447c1dcf.svg";